import { render, staticRenderFns } from "./EmployeeProfile.vue?vue&type=template&id=d7853140&scoped=true&"
import script from "./EmployeeProfile.vue?vue&type=script&lang=js&"
export * from "./EmployeeProfile.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeProfile.vue?vue&type=style&index=0&id=d7853140&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7853140",
  null
  
)

export default component.exports